// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  SWIPER_JS_LOADED: "fluco_section:swiper_js_loaded",
  LOOPING_SWIPER_INITIALIZED: "fluco_section:looping_swiper_initialized",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed",
  SHOP_THE_LOOK_HOTSPOT_CLICKED: "fluco_section:shop_the_look_hotspot_clicked"
};
var events_default = EVENTS;

// src/scripts/fluco-lib/load-swiper.js
var { SWIPER_JS_LOADED } = events_default;
function loadSwiper(functionName, passedThis) {
  if (window.Swiper) {
    passedThis[functionName]();
  } else {
    window.addEventListener(SWIPER_JS_LOADED, () => {
      passedThis[functionName]();
    });
  }
}

// src/scripts/fluco-lib/a11y.js
var handleTab = () => {
  const classes = {
    userIsTabbing: "fluco-user-is-tabbing"
  };
  const formElements = ["input", "textarea", "select"];
  function handleFirstTab(event) {
    if (event.key === "Tab" && !formElements.includes(document.activeElement.tagName.toLowerCase())) {
      document.body.classList.add(classes.userIsTabbing);
      window.addEventListener("mousedown", handleMouseDownOnce);
      window.removeEventListener("keydown", handleFirstTab);
    }
  }
  function handleMouseDownOnce() {
    document.body.classList.remove(classes.userIsTabbing);
    window.addEventListener("keydown", handleFirstTab);
    window.removeEventListener("mousedown", handleMouseDownOnce);
  }
  window.addEventListener("keydown", handleFirstTab);
};
var watchForTabbing = (callbackTabbing, callbackNotTabbing, passedThis) => {
  const classes = {
    userIsTabbing: "fluco-user-is-tabbing"
  };
  let tabbingState = false;
  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.target.classList.contains(classes.userIsTabbing)) {
        if (callbackTabbing && tabbingState === false) {
          tabbingState = true;
          passedThis[callbackTabbing]();
        }
      } else {
        if (callbackNotTabbing && tabbingState === true) {
          tabbingState = false;
          passedThis[callbackNotTabbing]();
        }
      }
    }
  });
  observer.observe(document.body, {
    attributeFilter: ["class"]
  });
  return observer;
};

// src/scripts/shared/fluco-shared-looping-swiper.js
var { SHOPIFY_BLOCK_SELECT, LOOPING_SWIPER_INITIALIZED } = events_default;
handleTab();
var LoopingSwiper = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      section: ".fluco-section",
      swiper: "[js-looping-swiper]",
      swiperWrapper: "[js-looping-swiper-wrapper]",
      originalSlide: ".swiper-slide[js-original-slide]",
      slideByBlockId: (id) => `.swiper-slide[data-block-id="${id}"]`,
      previousButton: "[js-swiper-prev-button]",
      nextButton: "[js-swiper-next-button]",
      originalSlideWithVideo: "[js-original-slide][js-has-video]",
      slideVideo: "video.fluco-looping-swiper-slide__video",
      slideImage: ".fluco-looping-swiper-slide__image",
      slideImageMobile: ".fluco-looping-swiper-slide__image-mobile",
      slideMediaContent: "[js-slide-media-content]",
      muteContainer: "[js-mute-container]",
      muteContainerByVideoId: (id) => `[js-mute-container][data-video-id="${id}"]`,
      paginationContainer: "[js-pagination-container]",
      pagination: "[js-pagination-item]"
    };
    this.attrs = {
      originalSlide: "js-original-slide",
      cloneSlide: "js-clone-slide",
      muteState: "data-mute-state",
      videoId: "data-video-id",
      activePagination: "data-active-pagination",
      hasVideoContent: "data-has-video-content",
      hasPagination: "data-has-pagination",
      videoPlayController: "data-video-play-controller",
      slideIndex: "data-slide-index",
      swiperSlideIndex: "data-swiper-slide-index"
    };
    this.state = {
      activeVideoEntry: null,
      activeCanvas: null,
      rafId: null,
      activeSlide: "active-slide",
      muted: "muted",
      unmuted: "unmuted"
    };
    this.classes = {
      canvasContainer: "fluco-looping-swiper-slide__canvas-container",
      videoCanvas: "fluco-looping-swiper-slide__canvas"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.initSlidesEventController();
    this.section = this.closest(this.selectors.section);
    this.swiper = this.querySelector(this.selectors.swiper);
    this.setupSwiper();
    if (window.Shopify.designMode) {
      this.parentElement.addEventListener(
        SHOPIFY_BLOCK_SELECT,
        (e) => this.setActiveBlock(e.detail.blockId),
        this.eventOptions
      );
    }
  }
  initSlidesEventController() {
    this.slidesEventController = new AbortController();
    this.slidesEventOptions = { signal: this.slidesEventController.signal };
  }
  resetSlidesEventController() {
    this.slidesEventController.abort();
    this.slidesEventController = new AbortController();
    this.slidesEventOptions = { signal: this.slidesEventController.signal };
  }
  setActiveBlock(blockId) {
    const currentBlockEl = this.querySelector(
      this.selectors.slideByBlockId(blockId)
    );
    this.swiperInstance.slideToLoop(
      parseInt(currentBlockEl.getAttribute(this.attrs.swiperSlideIndex), 10),
      0
    );
  }
  setupSwiper() {
    this.originalSlideSet = this.querySelectorAll(this.selectors.originalSlide);
    const originalSlideCount = this.originalSlideSet.length;
    const targetCount = 8;
    if (originalSlideCount < targetCount) {
      this.hasDuplicateSlides = true;
      const neededCloneSetCount = Math.ceil(
        (targetCount - originalSlideCount) / originalSlideCount
      );
      this.duplicateSlideContent(neededCloneSetCount);
    } else {
      this.hasDuplicateSlides = false;
    }
    this.hasVideoContent = this.swiper.getAttribute(this.attrs.hasVideoContent) === "true";
    if (this.hasVideoContent) {
      this.videoPlayController = this.swiper.getAttribute(
        this.attrs.videoPlayController
      );
      this.originalSlideWithVideos = this.querySelectorAll(
        this.selectors.originalSlideWithVideo
      );
      this.cachedVideosMap = new Map(
        Array.from(this.originalSlideWithVideos).map((slide) => {
          const video = slide.querySelector(this.selectors.slideVideo);
          return [
            slide.getAttribute(this.attrs.slideIndex),
            {
              video,
              currentTime: 0,
              isPlaying: false
            }
          ];
        })
      );
      if (this.hasDuplicateSlides) {
        this.updateDuplicateVideoDrawing();
      }
    }
    this.hasPagination = this.swiper.getAttribute(this.attrs.hasPagination) === "true";
    if (this.hasPagination) {
      this.paginationItems = this.querySelector(
        this.selectors.paginationContainer
      )?.querySelectorAll(this.selectors.pagination);
    }
    loadSwiper("initializeSwiper", this);
    this.sectionIO = this.loadSectionIO();
    this.tabbingObserver = watchForTabbing(
      "handleUserIsTabbing",
      "handleUserIsNotTabbing",
      this
    );
  }
  duplicateSlideContent(neededCloneSetCount) {
    for (let i = 0; i < neededCloneSetCount; i++) {
      this.originalSlideSet.forEach((slide) => {
        const clone = slide.cloneNode(true);
        const mediaContent = clone.querySelector(
          this.selectors.slideMediaContent
        );
        const video = clone.querySelector(this.selectors.slideVideo);
        if (video) {
          this.createCloneCanvas(
            mediaContent,
            video.getAttribute(this.attrs.slideIndex)
          );
          mediaContent.removeChild(video);
        }
        clone.removeAttribute(this.attrs.originalSlide);
        clone.toggleAttribute(this.attrs.cloneSlide, true);
        this.swiperWrapper = this.querySelector(this.selectors.swiperWrapper);
        this.swiperWrapper.appendChild(clone);
      });
    }
  }
  createCloneCanvas(container, slideIndex) {
    const wrapper = document.createElement("div");
    wrapper.classList.add(this.classes.canvasContainer);
    const canvas = document.createElement("canvas");
    canvas.classList.add(this.classes.videoCanvas);
    canvas.setAttribute(this.attrs.slideIndex, slideIndex);
    wrapper.appendChild(canvas);
    container.appendChild(wrapper);
  }
  updateDuplicateVideoDrawing() {
    const render = () => {
      const entry = this.state.activeVideoEntry;
      const canvas = this.state.activeCanvas;
      if (entry && !entry.video.paused && canvas) {
        const ctx = canvas.getContext("2d", { alpha: false });
        const dpr = window.devicePixelRatio || 1;
        canvas.width = canvas.clientWidth * dpr;
        canvas.height = canvas.clientHeight * dpr;
        this.drawVideo(ctx, entry.video, canvas);
      }
      this.state.rafId = requestAnimationFrame(render);
    };
    this.state.rafId = requestAnimationFrame(render);
  }
  drawVideo(ctx, video, canvas) {
    const videoObjectPosition = video.style.getPropertyValue("object-position").split(" ");
    const videoObjectPositionX = videoObjectPosition[0];
    const videoObjectPositionY = videoObjectPosition[1];
    const videoRatio = video.videoWidth / video.videoHeight;
    const canvasRatio = canvas.width / canvas.height;
    let sourceWidth, sourceHeight, sourceX, sourceY;
    if (videoRatio > canvasRatio) {
      sourceWidth = video.videoHeight * canvasRatio;
      sourceHeight = video.videoHeight;
      sourceX = (video.videoWidth - sourceWidth) / 2;
      sourceY = 0;
      switch (videoObjectPositionX) {
        case "left":
          sourceX = 0;
          break;
        case "right":
          sourceX = video.videoWidth - sourceWidth;
          break;
        default:
          sourceX = (video.videoWidth - sourceWidth) / 2;
          break;
      }
    } else {
      sourceWidth = video.videoWidth;
      sourceHeight = sourceWidth / canvasRatio;
      sourceX = 0;
      switch (videoObjectPositionY) {
        case "top":
          sourceY = 0;
          break;
        case "bottom":
          sourceY = video.videoHeight - sourceHeight;
          break;
        default:
          sourceY = (video.videoHeight - sourceHeight) / 2;
          break;
      }
    }
    ctx.drawImage(
      video,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      0,
      0,
      canvas.width,
      canvas.height
    );
  }
  initializeSwiper({ loop = true } = {}) {
    this.swiperInstance = new window.Swiper(this.swiper, {
      loop,
      slidesPerView: 1.1,
      speed: 250,
      // keep in sync with CSS transition
      grabCursor: true,
      centeredSlides: true,
      breakpoints: {
        720: {
          slidesPerView: 1.8
        },
        1024: {
          slidesPerView: 3.2
        },
        1136: {
          slidesPerView: 3.6
        }
      },
      navigation: {
        nextEl: this.querySelector(this.selectors.nextButton),
        prevEl: this.querySelector(this.selectors.previousButton)
      },
      on: {
        init: (swiper) => {
          if (this.hasVideoContent) {
            this.muteContainers = this.querySelectorAll(
              this.selectors.muteContainer
            );
            this.muteContainers?.forEach((muteContainer) => {
              muteContainer.addEventListener(
                "click",
                () => this.updateMuteState(muteContainer),
                { ...this.slidesEventOptions, passive: true }
              );
            });
            this.updateVideoState("0", swiper);
          }
          this.mediaContentSlides = this.querySelectorAll(
            this.selectors.slideMediaContent
          );
          this.mediaContentSlides?.forEach((mediaContentSlide) => {
            mediaContentSlide.addEventListener(
              "click",
              () => {
                swiper.slideToLoop(
                  parseInt(
                    swiper.clickedSlide.getAttribute(
                      this.attrs.swiperSlideIndex
                    ),
                    10
                  ),
                  500
                );
                if (this.hasPagination) {
                  this.updatePaginationState(
                    swiper.clickedSlide.getAttribute(
                      this.attrs.swiperSlideIndex
                    )
                  );
                }
              },
              this.slidesEventOptions
            );
          });
        },
        afterInit: () => {
          this.section.dispatchEvent(
            new Event(LOOPING_SWIPER_INITIALIZED, { bubble: true })
          );
        },
        resize: () => {
          this.section.dispatchEvent(
            new Event(LOOPING_SWIPER_INITIALIZED, { bubble: true })
          );
        },
        slideChangeTransitionStart: (swiper) => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          const activeIndex = activeSlide.getAttribute(this.attrs.slideIndex);
          this.muteAll();
          if (this.hasVideoContent && this.videoPlayController === this.state.activeSlide) {
            this.updateVideoState(activeIndex, swiper);
          }
          if (this.hasPagination) {
            this.updatePaginationState(activeIndex);
          }
        }
      }
    });
  }
  updateVideoState(activeSlideIndex, swiperInstance) {
    const swiper = swiperInstance;
    if (!swiper || !swiper.slides) return;
    if (this.state.activeVideoEntry) {
      this.state.activeVideoEntry.currentTime = this.state.activeVideoEntry.video.currentTime;
    }
    this.cachedVideosMap.forEach((entry2, index) => {
      if (index !== activeSlideIndex) {
        entry2.video.pause();
        entry2.isPlaying = false;
      }
    });
    const entry = this.cachedVideosMap.get(activeSlideIndex);
    this.state.activeVideoEntry = entry;
    const activeSlide = swiper.slides[swiper.activeIndex];
    const isOriginal = activeSlide.hasAttribute(this.attrs.originalSlide);
    this.state.activeCanvas = isOriginal ? null : activeSlide.querySelector("canvas");
    if (entry) {
      entry.video.currentTime = entry.currentTime;
      entry.video.play().catch(() => {
        console.warn("Autoplay blocked");
      });
      entry.isPlaying = true;
    }
  }
  updateMuteState(muteContainer) {
    const isMuted = muteContainer.getAttribute(this.attrs.muteState) !== this.state.muted;
    const targetId = muteContainer.getAttribute(this.attrs.videoId);
    const matchingMuteContainers = this.querySelectorAll(
      this.selectors.muteContainerByVideoId(targetId)
    );
    matchingMuteContainers.forEach((container) => {
      container.setAttribute(
        this.attrs.muteState,
        isMuted ? this.state.muted : this.state.unmuted
      );
    });
    this.cachedVideosMap.forEach(({ video }) => {
      if (video.id === targetId) video.muted = isMuted;
    });
  }
  muteAll() {
    if (!this.hasVideoContent) return;
    const muteContainers = this.querySelectorAll(this.selectors.muteContainer);
    muteContainers.forEach((container) => {
      container.setAttribute(this.attrs.muteState, this.state.muted);
    });
    this.cachedVideosMap.forEach(({ video }) => {
      video.muted = true;
    });
  }
  updatePaginationState(activeSlideIndex) {
    this.paginationItems.forEach((pagination) => {
      if (pagination.getAttribute(this.attrs.slideIndex) === activeSlideIndex) {
        pagination.setAttribute(this.attrs.activePagination, "");
      } else {
        pagination.removeAttribute(this.attrs.activePagination);
      }
    });
  }
  /**
   * Watches for section leaving view.
   */
  loadSectionIO() {
    const observer = new IntersectionObserver(
      this.handleSectionIntersect.bind(this)
    );
    observer.observe(this.section);
    return observer;
  }
  /**
   * Mute all videos when section is scrolled out of view.
   */
  handleSectionIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        this.muteAll();
      }
    });
  }
  /**
   * Destroys Swiper and re-initializes with looping off.
   */
  handleUserIsTabbing() {
    if (!this.swiperInstance) return;
    this.swiperInstance.destroy();
    this.resetSlidesEventController();
    this.initializeSwiper({ loop: false });
  }
  /**
   * Destroys Swiper and re-initializes with looping on.
   */
  handleUserIsNotTabbing() {
    if (!this.swiperInstance) return;
    this.swiperInstance.destroy();
    this.resetSlidesEventController();
    this.initializeSwiper({ loop: true });
  }
  disconnectedCallback() {
    this.eventController.abort();
    this.slidesEventController.abort();
    if (this.state.rafId) cancelAnimationFrame(this.state.rafId);
    this.swiperInstance?.destroy();
    this.sectionIO?.disconnect();
    this.tabbingObserver?.disconnect();
  }
};
if (!customElements.get("fluco-shared-v9-looping-swiper")) {
  customElements.define("fluco-shared-v9-looping-swiper", LoopingSwiper);
}
